import * as React from 'react';
import classNames from 'classnames';
import { useTheme } from '../useTheme';
import { Classes } from '../index';

type Props = {
  className?: string;
};

export const DialogBody: React.FC<Props> = ({ className, children }) => {
  const theme = useTheme();
  let cls = classNames(`${theme.ns}`, className, Classes.DIALOG_BODY);

  return <div className={cls}>{children}</div>;
};
